import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import { ContactRelationCategory } from '@contacts/interfaces/contact-relation-category';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';

@Component({
  name: 'bpc-contact-relation-category-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class ContactRelationCategoryTable extends mixins(AbstractTable) {
  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: ContactRelationCategory = null;
  public entityName = 'contact-relation-category';
  public pluralEntityName = 'contact-relation-categories';
  public permissionEntityNameToUse = 'contacts';

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'paginationLoaded',
    'orderLoaded',
  ];

  public customPageActions = {};
  public customRowActions = {};

  constructor() {
    super();
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  public get resolvedConfigFileName(): string {
    const fileName = this.entityName.replaceAll('-', '_');
    return this.configFileName
      ? this.configFileName
      : this.tenantType === 'center'
      ? fileName
      : `${fileName}_for_club`;
  }

  @Watch('entity', { deep: true })
  public onEntityChanged(entity: ContactRelationCategory) {
    if (entity?.default_for_family_management) {
      this.$set(this.$refs.stdForm?.formModel, 'can_manage_organization', true);
    }
  }

  /* Lifecycle hooks */

  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
